import { DomicilioGoogle } from 'shared/models/DomicilioGoogle';

export interface DomicilioModel
  extends Omit<DomicilioGoogle, 'pais' | 'codigoPostal'> {
  departamento: string | null;
  piso: string | null;
}

export const domicilioBuilder = {
  fromBackEnd: (dom): DomicilioModel => {
    const addressParts = [
      dom.street && dom.streetNumber 
        ? `${dom.street} ${dom.streetNumber}` 
        : dom.street || dom.streetNumber || null,
      dom.locality,
      dom.province,
    ].filter(part => part != null && part !== ""); 

    addressParts.push("Argentina");

    return {
      latitud: dom.latitude,
      longitud: dom.longitude,
      calle: dom.street,
      numero: dom.streetNumber,
      partido: dom.district,
      localidad: dom.locality,
      provincia: dom.province,
      departamento: dom.apartment,
      piso: dom.floor,
      text: addressParts.join(", "),
    };
  },
  toBackEnd: (dom: DomicilioModel) => {
    return {
      street: dom.calle,
      street_number: dom.numero === 's/n' ? 0 : Number(dom.numero),
      floor: dom.piso,
      apartment: dom.departamento,
      locality: dom.localidad,
      district: dom.partido,
      province: dom.provincia,
      latitude: dom.latitud,
      longitude: dom.longitud,
    };
  }
};
